import { Grid, Paper, Stack, Typography } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import AppContainer from "../../../components/AppContainer";
import CustomRangePicker from "../../../components/DateRangePicker";
import DynamicTable from "../../../components/DynamicTable";
import Loader from "../../../components/Loader";
import SnackbarAlert from "../../../components/SnackBar";
import { fetchAllSales } from "../../../services/Sales";
import ServicePieChart from "./ServicePieChart";
import moment from "moment";

const headerData = ["Service", "Sales"];
const tableRows = ["service", "service_recall"];

function DailySales() {
  const [isLoading, setIsLoading] = useState(false);
  const currentYear = moment().year();
  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  const [endDate, setEndDate] = useState(
    moment(`${currentYear}-12-31`).format("YYYY-MM-DD")
  );
  const [startDate, setStartDate] = useState(
    moment(`${currentYear}-01-01`).format("YYYY-MM-DD")
  );
  const [dailySales, setDailySales] = useState([]);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });
  useEffect(() => {
    handleFetchDailySales();
  }, []);

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({ open, type, message });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  const handleFetchDailySales = async () => {
    if (!selectedBranch) return;

    try {
      let params = {
        branchId: selectedBranch,
        startDate: startDate,
        endDate: endDate,
      };
      setIsLoading(true);
      const response = await fetchAllSales(params);

      if (response.status === 200 || response.status === 201) {
        setDailySales(response?.data?.data || []);
      } else {
        handleSnackbarVal(true, "error", response?.data?.message);
      }
    } catch (error) {
      handleSnackbarVal(true, "error", error?.message || "An error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDatesChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
  };

  return (
    <AppContainer
      primaryHeading="Daily Sales"
      secondaryHeading="View, filter and export the transactions and cash movement for the day."
      handleSearch={handleFetchDailySales}
      showSerachButton
      showDateRange={
        <CustomRangePicker
          stackProps={{
            boxShadow: "rgba(0, 0, 0, 0.09) 0px 3px 12px",
            borderRadius: "6px",
          }}
          handleDatesChange={handleDatesChange}
        />
      }
    >
      <Grid container spacing={1} overflow="hidden">
        <Grid item xs={12} md={8}>
          <Typography my={1} variant="h1" fontSize="1.125rem" fontWeight={600}>
            Transaction Summary
          </Typography>
          {dailySales?.length > 0 ? (
            <DynamicTable
              tableHeader={headerData}
              displayRows={tableRows}
              tableData={dailySales}
              minWidth={600}
            />
          ) : (
            <Stack height="100%" justifyContent="center">
              <Typography
                fontSize={18}
                fontWeight={800}
                color="#000"
                textAlign="center"
              >
                No Sale Found!
              </Typography>
            </Stack>
          )}
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper elevation={0} sx={{ height: 400 }}>
            <Typography
              my={1}
              variant="h1"
              fontSize="1.125rem"
              fontWeight={600}
            >
              Top Services
            </Typography>
            {dailySales?.length > 0 ? (
              <ServicePieChart data={dailySales} />
            ) : (
              <Stack height="100%" justifyContent="center">
                <Typography
                  fontSize={18}
                  fontWeight={800}
                  color="#000"
                  textAlign="center"
                >
                  No Sale Data Found!
                </Typography>
              </Stack>
            )}
          </Paper>
        </Grid>
      </Grid>
      <Loader isLoading={isLoading} />
      <SnackbarAlert
        handleCloseSnackbar={handleCloseSnackbar}
        snackbarProps={snackbarProps}
      />
    </AppContainer>
  );
}

export default DailySales;
